import { render, staticRenderFns } from "./AdmissionNote.vue?vue&type=template&id=d5b03edc"
import script from "./AdmissionNote.vue?vue&type=script&lang=js"
export * from "./AdmissionNote.vue?vue&type=script&lang=js"
import style0 from "./AdmissionNote.vue?vue&type=style&index=0&id=d5b03edc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports